import { render, staticRenderFns } from "./CategorizedItems.vue?vue&type=template&id=b65968cc&"
import script from "./CategorizedItems.vue?vue&type=script&lang=js&"
export * from "./CategorizedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports